import { defineMessages } from 'react-intl';

import { LoadLevel } from '@/shared/api/protocol-ts/model/dto_system_load_pb';

import { HighLoadLevel } from './types';

export const reportPipelineHighLoadMessages = defineMessages<HighLoadLevel>({
  [LoadLevel.LoadLevel_Medium]: {
    id: 'highLoad.reportPipeline.medium',
    defaultMessage:
      'The service is under increased load. Report generation may take longer than usual.',
  },
  [LoadLevel.LoadLevel_High]: {
    id: 'highLoad.reportPipeline.high',
    defaultMessage:
      'The service is temporarily under high load. Report generation may take significantly longer than usual.',
  },
});

export const uploadHighLoadMessages = defineMessages<HighLoadLevel>({
  [LoadLevel.LoadLevel_Medium]: {
    id: 'highLoad.upload.medium',
    defaultMessage:
      'The service is under increased load. Processing of uploaded studies may take longer than usual.',
  },
  [LoadLevel.LoadLevel_High]: {
    id: 'highLoad.upload.high',
    defaultMessage:
      'The service is temporarily under high load. Processing of uploaded studies may take significantly longer than usual.',
  },
});
